<template>
  <v-row justify="center">
    <v-btn
      large
      text
      block
      class="ma-auto"
      @click="dialog = true"
    >
      Reporte
    </v-btn>

    <v-dialog
      v-model="dialog"
      width="450"
    >
      <div v-if="!info">
        <span>Cargando...</span>
        <v-progress-linear
          indeterminate
          color="primary"
        />
      </div>

      <v-card v-else>
        <div ref="content">
          <v-subheader>
            REPORTE DETALLADO: NIVEL {{ item + 1 }}
            <v-spacer />
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-show="!!copyText"
                  icon
                  v-bind="attrs"
                  @click="clipboardCopy"
                  v-on="on"
                >
                  <v-icon>
                    mdi-clipboard-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>Copiar Reporte Nivel {{ item + 1 }}</span>
            </v-tooltip>
          </v-subheader>
          <v-divider />
          <v-card-title
            v-if="typeUser != 'student'"
            class="text-caption text-left mx-auto"
          >
           <div>
              <strong>Evaluación: </strong> {{ level.quiz_id }}
            </div>
            <div>
              <strong>Usuario: </strong> {{ student.name }}
            </div>
            <div>
              <strong>Fecha de finalización del nivel:</strong> {{ formatDate(level.end_time) }}
            </div>
            <div>
              <strong>Tiempo total de juego (hh:mm:ss):</strong> {{ level.play_time === '99:99' ? '00:00:00' : level.play_time }}
            </div>
            <div>
              <strong>Tiempo total de resolución de multiplicaciones (hh:mm:ss):</strong> {{ timeTotalMultiplication }}
            </div>
            <div>
              <strong>Tiempo promedio de respuesta (por multiplicación) (hh:mm:ss):</strong> {{ timeAvgMultiplication }}
            </div>
            <div>
              <strong>Tiempo promedio de lectura (por cuadro de texto) (hh:mm:ss):</strong> {{ timeAvgReading }}
            </div>
          </v-card-title>
          <v-card-text class="mt-2">
            <div
              v-for="(exercise, index) in listsExercises.exercises"
              :key="index"
              dense
              class="text-caption ml-5"
            >
             <div v-if="typeUser != 'student'" >
              {{ index + 1 }}) {{ exercise.multiplicand }} * {{ exercise.multiplier }} {{ questionStatus(level.answers[index]).text }}
              </div>
              <div v-else>
              {{ index + 1 }}) {{ questionStatus(level.answers[index]).text }}
              </div>
              <!-- {{ index + 1 }}) {{ exercise.multiplicand }} * {{ exercise.multiplier }} {{ questionStatus(level.answers[index]).text }} -->
            </div>
            <span class="font-weight-bold text-caption">
              Respuestas correctas: {{ totalCorrect }}/{{ totalAnswered }}
            </span>
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import firebase from 'firebase/app'
  import axios from 'axios'
  import moment from 'moment'
  moment.locale('es')
  export default {
    props: {
      item: {
        type: Number,
        default: 0,
      },
      level: {
        type: Object,
        default: () => {},
      },
      typeUser: {
        type: String,
        default: 'student',
      },
      student: {
        type: Object,
        default: () => {},
      },
    },
    data () {
      return {
        dialog: false,
        listsExercises: {
          listsExercises: [],
        },
        totalCorrect: 0,
        totalAnswered: 0,
        timeTotalMultiplication: 0,
        timeAvgMultiplication: 0,
        timeAvgReading: 0,
        info: false,
        copyText: null,
      }
    },
    computed: {
      test () {
        return this.$refs.content?.innerText
      },
    },
    watch: {
      dialog (val) {
        this.copyText = null
        val && this.init()
      },
    },
    methods: {
      clipboardText () {
        this.copyText = this.$refs.content.innerText
      },
      clipboardCopy () {
        this.$copyText(this.copyText, this.$refs.content)
      },
      async init () {
        this.copyText = ''
        const storage = firebase.storage()
        const storageRef = storage.ref()
        const objectRef = storageRef.child(`Quizzes/Ejercicios${this.item + 1}.json`)

        const url = await objectRef.getDownloadURL()
        const response = await axios.get(url)
        this.listsExercises = response.data
        this.totalCorrect = this.level.answers.split('2').length - 1
        this.totalAnswered = 20 - (this.level.answers.split('0').length - 1)
        this.timeTotalMultiplication = this.formatSeconds(this.level.solve_time)
        this.timeAvgMultiplication = this.totalAnswered > 0 ? this.formatSeconds(this.level.solve_time / this.totalAnswered) : '00:00:00'
        this.timeAvgReading = this.level.text_count > 0 ? this.formatSeconds(this.level.story_time / this.level.text_count) : '00:00:00'
        this.info = true
        setTimeout(() => {
          this.clipboardText()
        }, 1000)
      },
      questionStatus (status) {
        if (status === '0') {
          const st = {
            icon: 'mdi-emoticon-neutral-outline',
            text: '(multiplicación no resuelta)',
            color: 'info',
          }
          return st
        } else if (status === '1') {
          const st = {
            icon: 'mdi-emoticon-sad-outline',
            text: '(incorrecta)',
            color: 'red',
          }
          return st
        } else {
          const st = {
            icon: 'mdi-emoticon-happy-outline',
            text: '(correcta)',
            color: 'success',
          }
          return st
        }
      },
      formatDate (date) {
        if (date) {
          return moment(date).format('DD/MM/YYYY HH:mm:ss')
        } else {
          return 'Nivel no finalizado'
        }
      },
      multiplication (m1, m2) {
        return m1 * m2
      },
      formatSeconds (seconds) {
        return moment()
          .hours(0)
          .minutes(0)
          .seconds(Math.round(seconds))
          .format('HH:mm:ss')
      },
    },
  }
</script>
